var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.695 1 5 7.707v16.858L15.695 31l10.967-6.435V7.707L15.695 1zm-.997 5.438v-1.89l-1.634.95-5.62 3.262-.54.315v14.007l.508.32 5.62 3.536 1.666 1.048V6.438zm3.784-.955-1.609-.877V27.92l1.64-.969 5.983-3.533.534-.316v-6.148h-3.625v2.175h1.45v2.733l-3.807 2.25V8.27l3.807 2.076v3.887h2.175V9.056l-.567-.309-5.981-3.263zM9.079 21.88V10.327l3.443-2v15.72L9.079 21.88z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOg);
export default __webpack_public_path__ + "static/media/OG.c6e30cd979005f3d2856d019b4c9d1ed.svg";
export { ForwardRef as ReactComponent };